import { Logger } from "@utils/logger";
import { useSelector } from "react-redux";
import { getDontRenderUI, getTMXAutoSubmit, getTmxInDCUI, getTMXSessionId } from "@redux/selectors/verification-configuration-selectors";
import { TMXComponent } from "./tmx-component";
import { LoadingSpinner } from "../../common/loading-spinner/loading-spinner";

type TMXContainerProps = {
    setHasFinishedTMXProfiling: (hasFinished: boolean) => void;
    submitForm: () => Promise<void>;
};

export const TMXContainer = (props: TMXContainerProps) => {
    const {
        setHasFinishedTMXProfiling,
        submitForm
    } = props;

    const tmxSessionId = useSelector(getTMXSessionId);
    const tmxInDCUI = useSelector(getTmxInDCUI);
    const dontRenderUI = useSelector(getDontRenderUI);
    const tmxAutoSubmit = useSelector(getTMXAutoSubmit);

    const onTMXProfilingCompleted = (sessionID: string) => {
        Logger.info('[TMX] tmxProfilingCompleted with sessionID', sessionID);
        setHasFinishedTMXProfiling(true);

        if (!window.idwPageHasLoaded) {
            window.idwPageHasLoaded = true;
        }

        if (tmxAutoSubmit) {
            submitForm();
            Logger.info('[TMX] tmxProfilingCompleted step form auto submitted');
        } else {
            Logger.info('[TMX] tmxProfilingCompleted step done');
        }
    };

    const onTMXLoadError = (error: string) => {
        Logger.error('[TMX] Script load failed with error: ', error);
        setHasFinishedTMXProfiling(true);

        if (!window.idwPageHasLoaded) {
            window.idwPageHasLoaded = true;
        }

        if (tmxAutoSubmit) {
            submitForm();
            Logger.info('[TMX] tmxLoadError - form auto submitted');
        }
    };

    if (!tmxSessionId || tmxInDCUI) {
        return null;
    }

    return (
        <TMXComponent
            onTMXProfilingComplete={onTMXProfilingCompleted}
            onTMXLoadError={onTMXLoadError}
        >
            {dontRenderUI && <LoadingSpinner loadingText="Working..." />}
        </TMXComponent>
    );
};